import magnifiAPIInstance from "./apiInstance";

export const graphicAPIs = {
  getGraphics: ({ payload }) => magnifiAPIInstance.post(`/get_image`, payload),
  deleteGraphics: ({ payload }) => magnifiAPIInstance.post(`/delete_image`, payload),
  uploadGraphics: ({ payload }) => magnifiAPIInstance.post(`/add_image`, payload),
  getGraphicsById: ({ id }) => magnifiAPIInstance.get(`/api/v3/get_image_details/${id}`),
};
